module.exports = __webpack_public_path__ + "img/TcoTeam.d45b3e1b.png";